// import { Injectable } from '@angular/core';
// import {
//   HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { finalize, catchError } from 'rxjs/operators';

// @Injectable()
// export class ButtonDisableInterceptor implements HttpInterceptor {

//   // APIs to exclude
//   private excludedUrls: string[] = [
//     '/api/auth/signin',
//   ];

//   constructor() {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     
//     if ((req.method === 'POST'|| req.method === 'PUT') && !this.isExcluded(req.url)) {
//       this.setSubmittingState(true);

//       return next.handle(req).pipe(
//         catchError((error: HttpErrorResponse) => {
//           return throwError(() => error);
//         }),
//         finalize(() => {
//           this.setSubmittingState(false);
//         })
//       );
//     }

//     return next.handle(req);
//   }

//   private isExcluded(url: string): boolean {
//     return this.excludedUrls.some(excluded => url.includes(excluded));
//   }

//   private setSubmittingState(isSubmitting: boolean) {
//     const buttons = document.querySelectorAll('button[type="submit"]');

//     buttons.forEach(btn => {
//       const htmlBtn = btn as HTMLButtonElement;

//       if (isSubmitting) {
//         htmlBtn.disabled = true;
//         htmlBtn.setAttribute('data-original-text', htmlBtn.innerHTML);
//         htmlBtn.innerHTML = `
//           <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//           Loading...
//         `;
//       } else {
//         htmlBtn.disabled = false;
//         const originalText = htmlBtn.getAttribute('data-original-text');
//         if (originalText) {
//           htmlBtn.innerHTML = originalText;
//           htmlBtn.removeAttribute('data-original-text');
//         }
//       }
//     });
//   }
// }


//the above code is replaced with the below code because of sometimes it is working in forms inside mat-dialog and sometimes not working

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';

@Injectable()
export class ButtonDisableInterceptor implements HttpInterceptor {

  // exclude any auth or other endpoints you don't want to affect
  private excludedUrls: string[] = [
    '/api/auth/signin',
    '/api/v1/get_all_user_notification'
  ];

  // track how many requests are inflight per button (handles parallel calls)
  private btnCounters = new WeakMap<HTMLButtonElement, number>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // only act on mutating calls and not excluded urls
    if ((req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') && !this.isExcluded(req.url)) {

      const activeBtn = this.getActiveSubmitButton();
      if (activeBtn) {
        this.setButtonSubmittingState(activeBtn, true);
      } else {
        this.setSubmittingStateForAll(true);
      }

      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error)),
        finalize(() => {
          if (activeBtn) {
            this.setButtonSubmittingState(activeBtn, false);
          } else {
            this.setSubmittingStateForAll(false);
          }
        })
      );
    }

    return next.handle(req);
  }

  private isExcluded(url: string): boolean {
    return this.excludedUrls.some(excluded => url.includes(excluded));
  }

  private getActiveSubmitButton(): HTMLButtonElement | null {
    const el = document.activeElement as HTMLElement | null;
    if (!el) return null;

    const btn = el.closest?.('button[type="submit"]') as HTMLButtonElement | null;
    return btn ?? null;
  }

  private setButtonSubmittingState(btn: HTMLButtonElement, isSubmitting: boolean) {
    const current = this.btnCounters.get(btn) ?? 0;

    if (isSubmitting) {
      if (current === 0) {
        btn.disabled = true;

        // store original content only once
        if (!btn.getAttribute('data-original-html')) {
          btn.setAttribute('data-original-html', btn.innerHTML);
          btn.setAttribute('data-original-width', btn.style.width || '');
          // keep width to avoid layout shift when spinner text is shorter/longer
          const rect = btn.getBoundingClientRect();
          btn.style.width = `${rect.width}px`;
        }

        btn.innerHTML = `
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          
        `;
      }
      this.btnCounters.set(btn, current + 1);
    } else {
      const next = Math.max(0, current - 1);
      if (next === 0) {
        btn.disabled = false;
        const originalHtml = btn.getAttribute('data-original-html');
        if (originalHtml !== null) {
          btn.innerHTML = originalHtml;
          btn.removeAttribute('data-original-html');
        }
        const originalWidth = btn.getAttribute('data-original-width');
        if (originalWidth !== null) {
          btn.style.width = originalWidth;
          btn.removeAttribute('data-original-width');
        }
      }
      this.btnCounters.set(btn, next);
    }
  }

  private setSubmittingStateForAll(isSubmitting: boolean) {
    const buttons = document.querySelectorAll('button[type="submit"]');
    buttons.forEach(btn => this.setButtonSubmittingState(btn as HTMLButtonElement, isSubmitting));
  }
}
